<template>

    <div class="user_wbox">
        <div class="inter">
            <div class="div1 t-flex">
                <div class="fl">

                    <usermenu></usermenu>
                </div>
                <div class="fr">

                    <div class="user_center">

                        <div class="user_de_ti" style="margin-bottom: 30px;">提现</div>

                        <div class="money_user">
                            <div class="text_1">
                                <p class="p1">账户余额</p>
                                <p class="p2">{{ userinfo.money }}</p>
                            </div>
                           <div class="text_2">
                                <div class="sp1" @click="$router.push('/withdraw_log')">提现记录</div> 
                            </div>
                        </div>



                        <div>
                            <div class="edit_pass_word" style="width: auto;" >
                                <div class="item t-flex t-flex-items-center">
                                    <div class="lable">
                                        真实姓名
                                    </div>
                                    <div class="input">
                                        <el-input v-model="name" placeholder="请输入真实姓名"></el-input>
                                    </div>

                                </div>
                                <div class="item t-flex t-flex-items-center">
                                    <div class="lable">
                                        支付宝手机号
                                    </div>
                                    <div class="input">
                                        <el-input v-model="account" placeholder="请输入支付宝手机号"></el-input>
                                    </div>
                                </div>
                                <div class="item t-flex t-flex-items-center">
                                    <div class="lable">
                                        提现金额
                                    </div>
                                    <div class="input">
                                        <el-input v-model="price" placeholder="请输入提现金额"></el-input>
                                    </div>
                                </div>
                                <div style="padding-top: 20px;">
                                    <div class="debtn" @click="tixian">提交</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
import usermenu from '@/components/dialogs/usermenu'
import {
    Notification,
    Message
} from 'element-ui'
import moment from 'moment';
export default {
    components: {
        usermenu

    },
    data() {
        return {
            account: "",
            name: "",
            price: "",

        }
    },
    computed: {
        userinfo() {
            return this.$store.getters.userinfo
        }
    },
    created: function (data) {

        this.$store.dispatch('getUserinfo')

    },
    watch: {
        $route() {

        }
    },
    methods: {


        tixian() {
            var that = this


            if(parseFloat(this.price) > parseFloat(this.userinfo.money)){
        
                Message.error({
					message: "账户余额不足",
					duration: 3000,
					offset: "580"
				})
                return;
            }



            this.rq.requests.post("api/game/user/tixian", {
                name: that.name,
                account: that.account,
                money: that.price,
            }).then(res => {

                Message.success({
                    message: "提交成功,等待审核",
                    duration: 3000
                })

                that.account = ''
                that.name = ''
                that.price = ''
                that.$store.dispatch('getUserinfo')



            }).catch(error => {
                Message.error({
                    message: error.msg,
                    duration: 3000
                })
            })

        },




    }


}
</script>